import Axios from 'axios';
import Vue from 'vue';
import Confirm from '../../components/confirmation/confirm.vue';
import Tab from "../../components/tab/tab.vue";
import moment from 'moment'

export default Vue.extend({
    components: {
        Confirm,
        Tab
    },

    data: () => ({
        
        id : 0,
        job_details_all:[],
        ctc : '',
        fte_intern : '',
        reqProf : [],
        jobDesc : '',
        reqMinEduQual : [],
        cmpany_name : '',
        job_title : '',
        categry : '',
        dataLoading : false,
        selected: [2],
        about : '',
        webLink : '',
        exam_dates : [],
        empType : '',
        wrkingMde : [],
        stream : [],
        employeeNo : 0,
        pot_offshore: '',
        cmpany_image:'',
    }),

    created(){
      this.id = this.$route.params.id
      localStorage.removeItem("JobId");
      this.job_details();
    },

    methods:{
      async job_details(){
        this.dataLoading = true;
        let token =  localStorage.getItem("jwt");
        localStorage.setItem("JobId",this.id)
        if (token) { 
          const auth = {
            headers: {authorization: token} 
          }  
          let response = await this.$http.get('/job/fetchParticularJob/'+this.id, auth)
           
          console.log(response);
          console.log(response.data);
          if (response.status === 200 && response.data.message){
            this.job_details_all = response.data.jobs;
            this.fte_intern = this.job_details_all.employment_type;
          //   this.reqProf = this.job_details_all.reqProf;
            this.cmpany_name = this.job_details_all.company_name;
            this.cmpany_image = this.job_details_all.company_profile_image;
            this.job_title = this.job_details_all.job_title;
            this.jobDesc = this.job_details_all.job_description,
            this.reqMinEduQual = this.job_details_all.degree,
            this.stream = this.job_details_all.semester,
          //   this.categry = this.job_details_all.category,
          //   this.about = this.job_details_all.about,
            this.webLink = this.job_details_all.company_website,
           
            this.wrkingMde = this.job_details_all.work_type,
            this.employeeNo = this.job_details_all.open_positions;
            this.pot_offshore = this.job_details_all.offshore_assignment;
            this.job_details_all.exam_dates.forEach(element => {
              console.log("enterbjhgh",element);
              let date = new Date(element * 1000)
              // let t = new Date(element*1000).toLocaleTimeString();

              let  day = moment.unix(element);
              this.exam_dates.push( day.format('MMMM Do YYYY, h:mm a'));

              // this.exam_dates.push(date.getDate()+
              //                   "-"+(date.getMonth()+1)+
              //                   "-"+date.getFullYear()+
              //                   " "+date.getHours()+
              //                   ":"+date.getMinutes()+
              //                   ":"+date.getSeconds()+'0');
            });
            

          }
          this.dataLoading = false;
        
        }
      },

      go_to_talent(){
        this.$router.push({ name: 'recomended_talent', params: { id: this.id } })
      },

      backPage() {
        window.history.back()
      },

      edit(jid){
        this.$router.push({ name: 'update_job-application', params: { id: jid } })
      },

      
  }
})